import { createApp } from 'vue'
import App from './App.vue'

import { createRouter, createWebHistory } from 'vue-router'
import Coffee from './components/CoffeeWriter.vue'


// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const vuetify = createVuetify({
  components,
  directives,
})


const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: Coffee
    }
  ]
})

const app = createApp(App)

app.use(router)
app.use(vuetify)

app.mount('#app')